module.exports = __webpack_public_path__ + "img/Diskurs.16fbce5a.jpg";